import gql from 'graphql-tag';


export const gqlValidateUsernameForSignup = gql`
  query signupInputLivecheck($username: String!) {
    signupInputLivecheck(username: $username) {
      errors { key, message }
      metadata
    }
  }
`;

export const gqlValidateEmailForSignup = gql`
  query signupInputLivecheck($email: String!) {
    signupInputLivecheck(email: $email) {
      errors { key, message }
      metadata
    }
  }
`;


export const gqlSubmitLoginForm = gql`
  mutation userLogin($input: LoginFormInput!) {
    userLogin(input: $input) {
      errors { key, message }
      jwt
    }
  }
`;


// Reference:
// https://facebook.github.io/relay/graphql/mutations.htm
export const gqlSubmitSignupForm = gql`
  mutation userSignup($input: SignupFormInput!) {
    userSignup(input: $input) {
      errors { key, message }
      metadata
    }
  }
`;

// NOTE: Because query params are included in a link which can be
// modified or deleted, leave them optional.
export const gqlConfirmSignupEmail = gql`
  query signupEmailConfirmation($token: String, $sig: String) {
    signupEmailConfirmation(token: $token, sig: $sig) {
      errors { key, message }
      jwt
    }
  }
`;


// NOTE: Required but technically optional params for surfacing errors.
export const gqlResendConfirmSignupEmail = gql`
  query confirmSignupEmailResend($token: String) {
    confirmSignupEmailResend(token: $token) {
      errors { key, message }
      metadata
    }
  }
`;

// Note Oauth not OAuth casing, b/c Absinthe does camelCase
// to snake_case magic in the backend and casing matters!!
export const gqlOauthRequestTwitter = gql`
  query oauthRequestTwitter {
    oauthRequestTwitter {
      errors { key, message }
      metadata
    }
  }
`;

// Just keep arg vars in snake_case, because they are pulled from url
// query params and in snake_case when parsed.
export const gqlOauthCallbackTwitter = gql`
  query oauthCallbackTwitter($oauth_token: String!, $oauth_verifier: String!) {
    oauthCallbackTwitter(oauth_token: $oauth_token, oauth_verifier: $oauth_verifier) {
      errors {
        key,
        message
      }

      oauthUser {
        platform,
        username,
        profile_image_url,
        oauth_token,
        oauth_token_cipher
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/shared/gql/auth.js